<template>
  <div class="menu-fix">
    <!-- 侧边栏 -->
    <div class="menu-left">
      <div class="sidebar-logo-container">
        <img :src="config
          ? fullImage(config.icon)
          :'http://yl.sz90.cn/favicon.png'" class="sidebar-logo">
        <div class="sidebar-title">{{ config ? config.nick_name : '智慧健康' }}</div>
      </div>
      <ul class="menu-ul menu-side" v-if="$store.state.menuId">
        <li :class="{'p-left-menu':true,'active':item.id==$store.state.menuId}"
          v-for="(item,index) in $store.state.menu" :key="index" @click.self="onClickMenu(index)">
          <i v-if="item.thumb && item.thumb.indexOf('icon-') !=-1" :class="'iconfont '+(item.thumb?item.thumb:'')"></i>
          <img v-else
            :src="item.thumb && item.thumb.indexOf('/uploads') != -1?total_url+item.thumb:'https://'+item.thumb"
            style="width: 16px;height: 16px;margin-right: 10px;">
          {{ item.title }}
        </li>
      </ul>
    </div>
    <!--  end  -->
    <!-- 隐藏的子侧边栏 -->
    <template v-if="showMenu">
      <div ref="menuRef" class="menu-right" v-for="(item,index) in $store.state.menuItem[$store.state.menuId]"
        :key="index">
        <div class="right-menu-header">{{ item.title }}</div>
        <div class="right-menu-item" v-for="(val,key) in item.children" :key="key">
          <div class="item-label" @click="toggleClass($event)">
            <span>{{ val.title}}</span>
            <i style="font-size: 12px;" class="iconfont icon-arrow-right-copy-copy"
              :class="{'icon-xiala1': $store.state.menuSonId == val.id}"></i>
          </div>
          <div class="right-menu-item-content" :class="{'active-menu-item-content': $store.state.menuSonId == val.id}">
            <div :class="{'item-title':true,'active':$route.path=='/admin'+value.path}"
              v-for="(value,ind) in val.children" :key="ind" @click="openUrl($event,value,val)">{{ value.title }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="show-btn" v-if="showMenu" @click="changeType">
      <i style="font-size: 16px;font-weight: bold;" class="iconfont"
        :class="($store.state.Indent?'icon-suojinzuo':'icon-suojinyou')"></i>
    </div>
  </div>
</template>

<script>
  var _this;
  export default {
    name: 'Index',
    data() {
      return {
        ImgUrl: this.ImgUrl,
        total_url: this.totalUrl,
        config: {
          icon: '',
          nick_name: ''
        },
      }
    },
    created() {
      _this = this;
      this.init()
    },
    computed: {
      showMenu() {
        return (this.$store.state.menuId && this.$store.state.menuItem[this.$store.state.menuId] && this.$store.state
          .menuItem[this.$store.state.menuId][0].children.length) ? true : false
      }
    },
    watch: {
      '$route.path': (val) => {
        // console.log(_this.$store.state);
      }
    },
    methods: {
      init() {
        var _this = this
        let token = localStorage.getItem('token');
        if (token != null) {
          this.requestApi('/adm/get_menu', {
            status: true
          }).then(function(res) {
            if (res.status) {
              _this.config = res.config
              _this.$nextTick(function() {
                _this.$store.dispatch("setMenu", res.menu)
                _this.$store.dispatch("setMenuItem", res.data)
                if (res.menu.length) _this.$store.dispatch("setMenuId", res.menu[0].id)
                var menu_id = sessionStorage.getItem('menu_id')
                if (menu_id) {
                  _this.$store.dispatch("setMenuId", menu_id)
                  _this.$store.dispatch("setMenuSHOW", true)
                }
                var menu_son_id = sessionStorage.getItem('menu_son_id')
                if (menu_son_id) _this.$store.dispatch("setMenuSonId", menu_son_id)
              })
            }
          }).catch(function(error) {
            _this.alertErr(error)
          })
        }
      },
      // 点击一级导航栏 判断是否有下级 没有则跳转
      onClickMenu(index) {
        var item = this.$store.state.menu[index];
        if (this.$store.state.menuId == item.id) return false
        this.$store.dispatch("setMenuId", item.id)
        sessionStorage.setItem('menu_id', item.id)
        var children = this.$store.state.menuItem[item.id][0]
        if (children.children.length) {
          var obj = ''
          if (children.children[0].children.length) {
            obj = children.children[0].children[0]
            this.$store.dispatch("setMenuSonId", children.children[0].id)
            sessionStorage.setItem('menu_son_id', children.children[0].id)
          } else obj = children.children[0]
          if (obj != '') this.$store.dispatch("addTag", obj)
          this.$store.dispatch("setMenuSHOW", true)
          this.toUrl(obj.path)
        } else {
          this.toUrl(children.path)
        }
      },
      // 点击第三级栏目、存储二级路由ID
      openUrl(e, item, val) {
        this.$store.dispatch("setMenuSonId", val.id)
        sessionStorage.setItem('menu_son_id', val.id)
        if (!item.path) return false
        this.toUrl(item.path)
        this.$store.dispatch("addTag", item)
      },
      //缩进、展开
      changeType() {
        var type = !this.$store.state.Indent
        this.$store.dispatch("setMenuSHOW", type)
      },
      //给相应event设置显示/隐藏class
      toggleClass(event) {
        var iconDom = event.currentTarget.lastChild
        if (iconDom.classList.contains('icon-arrow-right-copy-copy')) {
          iconDom.classList.toggle('icon-xiala1')
        } else {
          iconDom.classList.add('icon-arrow-right-copy-copy')
        }
        var dom = event.currentTarget.nextElementSibling
        if (dom.classList.contains('active-menu-item-content')) {
          dom.classList.remove('active-menu-item-content')
        } else {
          dom.classList.add('active-menu-item-content')
        }
      }
    }
  }
</script>

<style>
  @import "../../assets/css/public/menuleft.css";
</style>


// WEBPACK FOOTER //
// src/components/public/MenuLeft.vue